import { createRoute } from "@tanstack/react-router";

import { requirePlatformAdmin } from "@platform/auth/guards";
import { shellRoute } from "@platform/shell.route";
import { AdminTelemetryPage } from "./telemetry.page";

export const adminTelemetryRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/admin/telemetry",
	beforeLoad: ({ context }) => requirePlatformAdmin(context.queryClient),
	component: AdminTelemetryPage,
});
